<dv-grid [actions]="actions()">
  <ag-grid-angular
    dvPinSelectedRow
    dvGridInSidesheet
    class="ag-theme-devinco"
    [gridOptions]="gridOptions"
    (selectionChanged)="onSelectionChanged($event)">
  </ag-grid-angular>
</dv-grid>
